import { Typography } from 'antd';
import cn from 'classnames';
import type React from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  type TypographySize,
  type TypographyType,
  type TypographyWeight,
  generateTypographyColorClassName,
  generateTypographySizeClassName,
  generateTypographyWeightClassName,
} from '../typography';

import typographyStyles from '../typography.module.css';
import { useGetType } from './hooks';
import styles from './text.module.css';

export type TextProperties = {
  children?: ReactNode;
  size?: TypographySize;
  type?: TypographyType;
  uppercase?: boolean;
  weight?: TypographyWeight;
  withinLink?: { hasHoverEffect?: boolean };
} & Omit<React.ComponentProps<typeof Typography.Text>, 'type'>;

const Text = ({ children, className, size, type, uppercase, weight, withinLink, ...rest }: TextProperties) => {
  const { t } = useTranslation();
  const getType = useGetType();

  return (
    <Typography.Text
      {...rest}
      className={cn(
        className,
        styles.text,
        generateTypographySizeClassName(size),
        generateTypographyWeightClassName(weight),
        generateTypographyColorClassName(type),
        {
          [typographyStyles['typography--hover'] ?? '']: withinLink?.hasHoverEffect, // TODO add to title and paragraph?
          [typographyStyles['typography--uppercase'] ?? '']: uppercase === true,
        },
      )}
      type={getType(type)}
    >
      {typeof children === 'string' ? t(children) : children}
    </Typography.Text>
  );
};

export default Text;
